import _functionUncurryThis from "../internals/function-uncurry-this";
import _requireObjectCoercible from "../internals/require-object-coercible";
import _toString from "../internals/to-string";
var exports = {};
var uncurryThis = _functionUncurryThis;
var requireObjectCoercible = _requireObjectCoercible;
var toString = _toString;
var quot = /"/g;
var replace = uncurryThis("".replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = "<" + tag;
  if (attribute !== "") p1 += " " + attribute + "=\"" + replace(toString(value), quot, "&quot;") + "\"";
  return p1 + ">" + S + "</" + tag + ">";
};
export default exports;